import { useGlobalModals } from "@/app/providers/modal-provider"
import { Button } from "@/components/ui/button"

/**
 * Figma / ENT footer: cream page band, white rounded bar, centered copyright
 * + Terms link, CAUTION pill on the right.
 */
export function Footer() {
  const { openCaution } = useGlobalModals()
  const year = new Date().getFullYear()

  return (
    <footer className="bg-[#f9f5f2] px-4 pb-8 pt-2 sm:px-6">
      <div className="mx-auto grid max-w-[1200px] grid-cols-[1fr_auto] items-center gap-3 rounded-[26px] bg-white px-4 py-4 sm:grid-cols-[1fr_auto_1fr] sm:gap-4 sm:px-7 sm:py-[19px]">
        <span className="hidden sm:block" aria-hidden />

        <p className="m-0 text-left font-body text-[13px] font-medium leading-normal text-[#003333] sm:text-center sm:text-[16px]">
          <span>© {year}. All rights reserved.</span>
          <span className="mx-[0.35em] font-normal" aria-hidden>
            |
          </span>
          <a
            href="https://www.reliancefoundation.org/terms-conditions"
            target="_blank"
            rel="noopener noreferrer"
            className="underline underline-offset-2 hover:opacity-85"
          >
            Terms &amp; Conditions.
          </a>
        </p>

        <div className="flex justify-end">
          <Button
            type="button"
            className="h-[46px] cursor-pointer shrink-0 rounded-full bg-[#003333] px-6 font-body text-[13px] font-bold tracking-[0.06em] text-white uppercase hover:bg-[#004d4d] focus-visible:ring-brand-teal"
            onClick={openCaution}
          >
            Caution
          </Button>
        </div>
      </div>
    </footer>
  )
}
